import moment from "moment";
import { updateRequest } from "../../../constant/common";

export const serviceEntryTypes = [
    // {
    //     id: 0,
    //     label: "Create Service Entry",
    //     value: "createSE"
    // },
    {
        id: 1,
        label: "List Service Entry",
        value: "listSE"
    },
    {
        id: 2,
        label: "Pending Service Entry",
        value: "pendingSE"
    },
    {
        id: 3,
        label: "Ariba",
        value: "ariba"
    }
];

export const roleAccessMap = {
    C: ["createSE", "listSE", "ariba", "pendingSE"],
    U: ["createSE", "listSE"],
    A: ["listSE", "pendingSE"]
};

export const getServiceEntryDropdown = (roles = []) => {
    let allowedValues = new Set();

    roles.forEach(role => {
        (roleAccessMap[role] || []).forEach(v => allowedValues.add(v));
    });

    return serviceEntryTypes.filter(item => allowedValues.has(item.value));
};

export const initialFilter = {
    poNumber: "",
    plant: "",
    materialNo: "",
    dateHigh: "",
    dateLow: "",
    entrySheetNumber: "",
    year: "",
    uuid: "",
    lineItem: ""
}

export const steps = [
    "General",
    "Value",
    "Vendor",
    "DMS Attachment",
];

export const columnsList = [
    { label: "Select Line", hoverDescription: "Select Line Item", colKey: 'isChecked', type: 'checkbox', disabled: false },
    { label: "Service No", hoverDescription: "Service No", colKey: 'serNo', type: 'input', disabled: true },
    { label: "Service Pos", hoverDescription: "Service Pos", colKey: 'srvPos', type: 'input', disabled: true },
    { label: "Quantity", hoverDescription: "Quantity in unit of entry", colKey: 'quantity', type: 'input', disabled: false },
    { label: "Price ", hoverDescription: "price", colKey: 'price', type: 'input', disabled: false },
    { label: "Unit", hoverDescription: "Unit", colKey: 'unit', type: 'input', disabled: false },
    { label: "Short text", hoverDescription: "Short text", colKey: 'shortText', type: 'input', disabled: true },
    { label: "Net Value", hoverDescription: "Net Value", colKey: 'netValue', type: 'input', disabled: true },
];



export const sesModule = 'ses';


const formatDate = (date) => {
    if (!date || !moment(date).isValid()) return '';
    return moment(date).format("YYYYMMDD");
};


export const createReqObject = (rows = [], serviceRows = [], header = {}, fileData, sheetType, plant, globalFilter, userData) => {
    const itemNo = sheetType === 'createSE' ? rows[0]?.itemNo : header?.itemNo;
    // only include checked items in case of create screen
    const filteredRows = sheetType === "createSE"
        ? serviceRows.filter(row => row.isChecked)
        : serviceRows;

    const itemsList = filteredRows?.map((row) => {
        const item = updateRequest(row);
        return {
            serNo: item?.serNo || "",
            srvPos: item?.srvPos || "",
            quantity: item?.quantity || "",
            unit: item?.unit || "",
            price: item?.price || "",
            shortText: item?.shortText || "",
        };
    });

    return {

        header: {
            poNumber: String(header?.poNumber || ""),
            uuid: globalFilter?.uuid || "",
            entrySheetNumber: header?.entrySheetNumber || "",
            itemNo: itemNo || "",
            docDate: formatDate(header?.docDate) || "",
            postingDate: formatDate(header?.postingDate),
            shortText: header?.shortText,
            creator: sheetType === 'pendingSE' ? header?.creator : userData?.employeeId || "",
            vendor: header?.vendor || "",
            receivingVendor: header?.receivingVendor || "",
            attachment: fileData?.attachment || "",
            attachmentName: fileData?.fileName || "",
            attachmentExtension: fileData?.fileExtension || "",
            // plant: Array.isArray(plant) ? plant.map(p => p.value).filter(Boolean) : [],
            longText: sheetType === 'ariba' ? 'ARIBA' : '',
            docText: header?.docText,
            reference: header?.reference,
            actionInd: sheetType === 'createSE' ? 'C' : sheetType === 'pendingSE' ? 'A' : sheetType === 'ariba' ? 'U' : '',
        },
        serviceList: itemsList

    };
};

export const createReqObjForRev = (rows = [], serviceRows, sheetType, header = {}, fileData, entrySheetNumber) => {
    const itemsList = serviceRows.map((row) => updateRequest(row));
    // const itemsList = serviceRows.map((row) => {
    //     const item = updateRequest(row);
    //     return {
    //         serNo: item?.serNo || "",
    //     };
    // });

    return {
        header: {
            entrySheetNumber: entrySheetNumber || "",
            attachment: fileData?.attachment || "",
            attachmentName: fileData?.fileName || "",
            attachmentExtension: fileData?.fileExtension || "",
            actionInd: sheetType === 'listSE' ? 'D' : sheetType === 'pendingSE' ? 'X' : '',
            poNumber: header?.poNumber || "",
            uuid: header?.uuid || "",
            creator: header?.creator || "",
            itemNo: header?.itemNo || "",
            docText: header?.docText,
            reference: header?.reference,
        },
        serviceList: itemsList
    };
};

